module.exports = __webpack_public_path__ + "static/media/03-1-img.f8653065.png";